import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/pages/index/components/Header/Header';
import ViewOrder from './ViewOrder/ViewOrder';
import "./Profile.css";
import ProfileSideBar from './ProfileSideBar';
import UserProfile from './UserProfile/UserProfile';
import ManageAddresses from './ManageAddresses/ManageAddresses';
import Referrals from './Referrals/Referral';
import BuildCoins from './BuildCoins/BuildCoins';
import ProfileWishlist from './ProfileWishlist';
import PrivacySettings from './components/PrivacySettings';
import { useAuth } from '../Auth/AuthContext';
import NavigationMobileMenu from '@/shared/components/NavigationMobileMenu/NavigationMobileMenu';
import OrderDetails from './OrderDetails/viewOrderdetails';

type ActiveViewType = 'profile' | 'orders' | 'order-details' | 'address' | 'referrals' | 'build-coins' | 'wishlist' | 'privacy';

const Profile: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState<ActiveViewType>('profile');
  const [showMobileContent, setShowMobileContent] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/auth');
    }
  }, [isAuthenticated, isLoading, navigate]);
  if (isLoading) {
    return (
      <div className="profile-root">
        <Header />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
          <div>Loading...</div>
        </div>
      </div>
    );
  }
  if (!isAuthenticated) {
    return null;
  }

  const handleViewChange = (view: ActiveViewType, orderId: string | null = null) => {
    setActiveView(view);
    if (orderId) {
      setSelectedOrderId(orderId);
    }
    // On mobile, show content when a view is selected
    setShowMobileContent(true);
  };

  const handleBackToSidebar = () => {
    setShowMobileContent(false);
  };

  const renderActiveView = () => {
    switch (activeView) {
      case 'orders':
        return <ViewOrder onViewOrder={(orderId) => handleViewChange('order-details', orderId)} />;
      case 'order-details':
        return <OrderDetails orderId={selectedOrderId} onBack={() => handleViewChange('orders')} />;
      case 'address':
        return <ManageAddresses />;
      case 'referrals':
        return <Referrals />;
      case 'build-coins':
        return <BuildCoins />;
      case 'wishlist':
        return <ProfileWishlist />;
      case 'privacy':
        return <PrivacySettings />;
      case 'profile':
      default:
        return <UserProfile />;
        
    }
  };

  return (
    <div className="profile-root">
      <Header />
      <main className={`profile-layout ${showMobileContent ? 'mobile-content-active' : 'mobile-sidebar-active'}`}>
        <div className="profile-left">
          <ProfileSideBar 
            activeView={activeView}
            onViewChange={handleViewChange}
          />
        </div>
        <div className="profile-right">
          <button className="mobile-back-button" onClick={handleBackToSidebar}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Menu
          </button>
          {renderActiveView()}
        </div>
      </main>
      <NavigationMobileMenu />
    </div>
  );
};

export default Profile;
